import { HStack, Heading } from '@chakra-ui/react';
import { HeadingBlockViewProps } from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';
import { DocumentBlockItemViewProps } from '../item/documentItemView';

export function createDocumentHeadingView(
    config: ReportingViewBaseConfig & {
        BlockItem: React.FC<DocumentBlockItemViewProps>;
    }
): React.FC<HeadingBlockViewProps> {
    const { BlockItem } = config;

    return (props) => {
        const sizes = {
            1: '2xl',
            2: 'xl',
            3: 'lg',
        };
        return (
            <BlockItem as={<HStack align="center" />} {...props.block}>
                <Heading
                    as={`h${props.level as 1 | 2 | 3}`}
                    fontWeight="medium"
                    fontSize={sizes[props.level as keyof typeof sizes]}
                    color="whiteAlpha.800"
                >
                    {props.children}
                </Heading>
                {props.placeholder && (
                    <Heading
                        as={`h${props.level as 1 | 2 | 3}`}
                        fontWeight="medium"
                        fontSize={sizes[props.level as keyof typeof sizes]}
                        color="whiteAlpha.400"
                        userSelect="none"
                        position="absolute"
                        left={0}
                        top={0}
                    >
                        {props.placeholder}
                    </Heading>
                )}
            </BlockItem>
        );
    };
}
